import { Routes } from '@angular/router';
import { redirectUnauthorizedTo } from '@angular/fire/auth-guard';

import { AdminLayoutComponent } from '@admin/admin-layout.component';

import { onBoardingGuard } from '@core/guards/onboarding.guard';
import { AuthGuard } from '@core/guards/auth.guard';
import { billingGuard } from '@core/guards/billing.guard';

import { OnboardingComponent } from './onboarding/onboarding.component';
import { NoShowComponent } from './onboarding/calendar-connection/no-show/no-show.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['auth/login']);

export const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard],
    canActivateChild: [onBoardingGuard(true), billingGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToLogin,
    },
    runGuardsAndResolvers: 'always', // Ensures resolvers and guards run on page refresh
  },
  {
    path: 'getting-started',
    component: OnboardingComponent,
    loadChildren: () => import('./onboarding/onboarding.module').then((m) => m.OnboardingModule),
    canActivate: [AuthGuard],
    canActivateChild: [onBoardingGuard(false)],
    data: {
      authGuardPipe: redirectUnauthorizedToLogin,
    },
  },
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./auth/sign-in/sign-in.component').then((mod) => mod.SignInComponent),
      },
      {
        path: 'signup',
        loadComponent: () =>
          import('./auth/sign-up/sign-up.component').then((mod) => mod.SignUpComponent),
      },
      {
        path: 'forget-password',
        loadComponent: () =>
          import('./auth/forget-password/forget-password.component').then(
            (mod) => mod.ForgetPasswordComponent
          ),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./auth/reset-password/reset-password.component').then(
            (mod) => mod.ResetPasswordComponent
          ),
      },
      {
        path: 'verify',
        loadComponent: () =>
          import('./auth/email-verify/email-verify.component').then(
            (mod) => mod.EmailVerifyComponent
          ),
      },
      {
        path: 'verify-2fa',
        loadComponent: () =>
          import('./auth/verify-two-factor/verify-two-factor.component').then(
            (mod) => mod.VerifyTwoFactorComponent
          ),
      },
    ],
  },
  {
    path: 'social/callback/youtube',
    component: NoShowComponent,
  },
  {
    path: 'social/callback/twitter',
    component: NoShowComponent,
  },
  {
    path: 'social/callback/linkedin',
    component: NoShowComponent,
  },
  {
    path: 'social/callback/pinterest',
    component: NoShowComponent,
  },
  {
    path: 'social/callback/tiktok',
    component: NoShowComponent,
  },
  {
    path: 'social/callback/linkedin_page',
    component: NoShowComponent,
  },
  {
    path: 'social/callback/facebook_page',
    component: NoShowComponent,
  },
  {
    path: 'social/callback/instagram',
    component: NoShowComponent,
  },
  {
    path: 'social/callback/instagram_standalone',
    component: NoShowComponent,
  },
  {
    path: 'social/callback/threads',
    component: NoShowComponent,
  },
  {
    path: 'noshow',
    component: NoShowComponent,
  },
];
